import React from 'react';

import Sparkline, {
  Tooltip
} from 'devextreme-react/sparkline';

export default function RowTemplate(props: {data: any}) {
  return (
    <tr>
      <th style={{textAlign:'left'}}>{props.data.path}</th>
      <td>
        <Sparkline
          dataSource={props.data.info}
        //   showMinMax={true}
          ignoreEmptyPoints={false}
          showFirstLast={true}
          className="sparkline"
          argumentField="period"
          valueField="sessions"
          type="line"
          firstLastColor='orange'
          lineColor="green"
        >
          {/* <Tooltip format="currency" /> */}
        </Sparkline>
      </td>

    </tr>
  );
}




// WEBPACK FOOTER //
// ./src/components/ReportComponents/RowTemplate.tsx